/* eslint-disable no-unused-vars */
import { useContext, memo } from 'react';
import { DropDownSearch } from './components/dropDownSearch/DropDownSearch';
import { ExportIcon } from 'assets/icons';
import * as S from './FilterBar.styled';
import { ManageCampaignsContext } from 'contexts';
import { FilterSelectedItems } from './components/filterSelectedItems/FilterSelectedItems';
import { FiltersBtn } from './components/filtersBtn/FiltersBtn';
import { ColumnsBtn } from './components/columnsBtn/ColumnsBtn';
import { ExportBtn } from './components/exportBtn/ExportBtn';

export const FilterBar = memo(() => {
  const {
    campaignData$,
    selectedAppsAndCampaigns,
    selectedStatusFilter$,
    selectedTypeFilter$,
    selectedAppTypeFilter$,
    deleteSelectedItem,
    deleteSelectedStatusFilter,
    deleteSelectedTypeFilter,
    deleteSelectedAppTypeFilter,
    selectedCountriesFilter$,
    all_countries,
    handleDeselectCountry,
    clearAll,
    statuses,
    types,
    appTypes,
    appNumberToAppName,
    campNumberToCampName,
  } = useContext(ManageCampaignsContext);

  if (!campaignData$.value?.campaignsData) return null;
  return (
    <>
      <S.Container>
        <DropDownSearch />
        <FiltersBtn />
        <ExportBtn />
        <ColumnsBtn />
      </S.Container>
      <FilterSelectedItems
        deleteSelectedTypeFilter={deleteSelectedTypeFilter}
        selectedAppsAndCampaigns={selectedAppsAndCampaigns}
        deleteSelectedItem={deleteSelectedItem}
        selectedStatusFilter$={selectedStatusFilter$}
        selectedTypeFilter$={selectedTypeFilter$}
        selectedAppTypeFilter$={selectedAppTypeFilter$}
        deleteSelectedStatusFilter={deleteSelectedStatusFilter}
        selectedCountriesFilter$={selectedCountriesFilter$}
        deleteSelectedAppTypeFilter={deleteSelectedAppTypeFilter}
        all_countries={all_countries}
        handleDeselectCountry={handleDeselectCountry}
        clearAll={clearAll}
        statuses={statuses}
        types={types}
        appTypes={appTypes}
        appNumberToAppName={appNumberToAppName}
        campNumberToCampName={campNumberToCampName}
      />
    </>
  );
});

FilterBar.displayName = 'FilterBar';
